/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useRef} from 'react';
import {  
  TableHead,
  TableSubHeader,
  DarkStickyMainHeader,
  TableBody,
  TableRow,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
  TableColumn,
  TableDefault,
  ArrowHolderSummary,
  DarkStickyShadowMainHeader,
  WrapperSortingTableHead,
  ColumnContainerSummary,
} from './styles';
import {Radio, InputCheckbox} from '..';
import Utils, {deepGet} from '../../utils/api/Utils';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import { capitalizeFirstLetters } from '../../utils/hooks/text-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
import TooltipFatigueZones from '../TooltipFatigueZones/TooltipFatigueZones';
import {ArmFatigue, ArmStrength} from '../../utils/constants/fatigueZonesInfo';
import {Oval} from '../../pages/players/styles';
import {handleDate} from '../../utils/helpers/handleDate';

function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
  medical,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
  medical?: boolean;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({one: false, two: false});
  const [check, useCheck] = useState<any>({zone_1: false, zone_2: false, zone_3: false});

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }
    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'zone 1';
      }
      if (item === 'zone_2') {
        item = 'zone 2';
      }
      if (item === 'zone_3') {
        item = 'zone 3';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }

  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = {one: true, two: false};
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = {one: false, two: true};
      useReverse(true);
      useRadio(ascendent);
    }
  }

  if (visible === popup_id) {
    return (
      <SortPopUp posY={43}>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px'}} />
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({...check, zone_1: !check.zone_1})} />
              <PopUpText onClick={() => useCheck({...check, zone_1: !check.zone_1})}>Watch</PopUpText>
              <Oval size={'16'} color={'watch'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({...check, zone_2: !check.zone_2})} />
              <PopUpText onClick={() => useCheck({...check, zone_2: !check.zone_2})}>Warning</PopUpText>
              <Oval size={'16'} color={'warning'} />
            </CheckBoxWrapper>
            {medical && (
              <CheckBoxWrapper>
                <InputCheckbox checked={check.zone_3} onClick={() => useCheck({...check, zone_3: !check.zone_3})} />
                <PopUpText onClick={() => useCheck({...check, zone_3: !check.zone_3})}>Medical</PopUpText>
                <Oval size={'16'} color={'medical'} />
              </CheckBoxWrapper>
            )}
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}

export default ({ dataTableContent }: { dataTableContent: Array<any> }) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [popUp, usePopup] = useState<string>('');
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(true);
  const sortOptions = [!reverse, changeTable, table];
  const [tooltipSection, setTooltipSection] = useState<any>([ArmStrength, 'totalStrength']);
  const tooltipRef = useRef<HTMLInputElement | any>(document.createElement('div'));
  const UTILS = new Utils();

  useEffect(() => {
    toggleSortDate('date', ['date'])
  }, [])

  function changeTable(e) {
    useTable([...e]);
  }
  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }  

  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }

  function closeSorts() {
    usePopup('');
    useSort('');
  }

  function SortingTable({title='', attr, location, bgColor='', sortFunction}) {
    return (
      <WrapperSortingTableHead bgColor={bgColor} onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </WrapperSortingTableHead>
    );
  }

  function hoverOval(event, tooltipInfo) {
    let top = Number(event.clientY) + 10;
    let left = Number(event.clientX) + 10;
    if (Number(window.innerWidth) - Number(event.clientX) < 200) {
      left = Number(event.clientX) - 200;
    }
    if (Number(window.innerHeight) - Number(event.clientY) < 180) {
      top = Number(event.clientY) - 150;
    }
    tooltipRef.current.style.display = 'block';
    tooltipRef.current.style.inset = top + 'px 0px 0px ' + left + 'px';
    setTooltipSection(tooltipInfo);
  }

  function hideTooltip() {
    tooltipRef.current.style.display = 'none';
  }

  return (
    <>
      <TableDefault boxShadow='none' minWidth={'1360px'}>
        <TableHead>          
          <TableRow>
            <DarkStickyShadowMainHeader colSpan={1}>POST EXAM</DarkStickyShadowMainHeader>
            <DarkStickyMainHeader colSpan={3}>EVENT</DarkStickyMainHeader>
            <DarkStickyShadowMainHeader colSpan={2}>TOTAL STRENGTH</DarkStickyShadowMainHeader>
            <DarkStickyMainHeader colSpan={2}>INTERNAL ROTATION</DarkStickyMainHeader>
            <DarkStickyShadowMainHeader colSpan={2}>EXTERNAL ROTATION</DarkStickyShadowMainHeader>
            <DarkStickyMainHeader colSpan={2}>SCAPTION</DarkStickyMainHeader>
            <DarkStickyShadowMainHeader colSpan={2}>GRIP</DarkStickyShadowMainHeader>
          </TableRow>
          <TableRow>
            <SortingTable title="Sort date" attr="date" location={['date']} bgColor={'#ebedf2'} sortFunction={toggleSortDate} />
            <SortingTable title="Type" attr="type" location={['event', 'type']} bgColor={'#f7f8fa'} sortFunction={toggleSortString} />
            <TableSubHeader border={'none'} cursor={'pointer'} bgColor={'#f7f8fa'}>
              <span onClick={() => togglePopUp('pu_0')}>Pitches</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['event', 'pitches']}
                popup_id={'pu_0'}
                visible={popUp}                
              />
            </TableSubHeader>        
            <SortingTable title="RPE" attr="rpe" location={['event', 'rpe']} bgColor={'#f7f8fa'} sortFunction={toggleSortNumber} />    
            <TableSubHeader border={'none'} cursor={'pointer'} bgColor={'#ebedf2'}>
              <span onClick={() => togglePopUp('pu_1')}>% Fresh</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['strength', 'freshTotalRatio']}
                popup_id={'pu_1'}
                visible={popUp}
                includeAlerts={true}
                status={['strength', 'armFatigueTotal']}
              />
            </TableSubHeader>            
            <SortingTable title="Change (lbs)" attr="freshTotalChange" location={['strength', 'freshTotalChange']} bgColor={'#ebedf2'} sortFunction={toggleSortNumber} />    
            <TableSubHeader border={'none'} cursor={'pointer'} bgColor={'#f7f8fa'}>
              <span onClick={() => togglePopUp('pu_2')}>% Fresh</span>        
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['strength', 'freshIRRatio']}
                popup_id={'pu_2'}
                visible={popUp}
                includeAlerts={true}
                status={['strength', 'armFatigueIR']}
              />      
            </TableSubHeader>            
            <SortingTable title="Change (lbs)" attr="freshIRChange" location={['strength', 'freshIRChange']} bgColor={'#f7f8fa'} sortFunction={toggleSortNumber} />    
            <TableSubHeader border={'none'} cursor={'pointer'} bgColor={'#ebedf2'}>
              <span onClick={() => togglePopUp('pu_3')}>% Fresh</span> 
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['strength', 'freshERRatio']}
                popup_id={'pu_3'}
                visible={popUp}
                includeAlerts={true}
                status={['strength', 'armFatigueER']}
              />             
            </TableSubHeader>
            <SortingTable title="Change (lbs)" attr="freshERChange" location={['strength', 'freshERChange']} bgColor={'#ebedf2'} sortFunction={toggleSortNumber} />    
            <TableSubHeader border={'none'} cursor={'pointer'} bgColor={'#f7f8fa'}>
              <span onClick={() => togglePopUp('pu_4')}>% Fresh</span>    
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['strength', 'freshScaptionRatio']}
                popup_id={'pu_4'}
                visible={popUp}
                includeAlerts={true}
                status={['strength', 'armFatigueScaption']}
              />          
            </TableSubHeader>
            <SortingTable title="Change (lbs)" attr="freshScaptionChange" location={['strength', 'freshScaptionChange']} bgColor={'#f7f8fa'} sortFunction={toggleSortNumber} />    
            <TableSubHeader border={'none'} cursor={'pointer'} bgColor={'#ebedf2'}>
              <span onClick={() => togglePopUp('pu_5')}>% Fresh</span>   
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['strength', 'freshGripRatio']}
                popup_id={'pu_5'}
                visible={popUp}
                includeAlerts={true}
                status={['strength', 'armFatigueGrip']}
              />                     
            </TableSubHeader>
            <SortingTable title="Change (lbs)" attr="freshGripChange" location={['strength', 'freshGripChange']} bgColor={'#ebedf2'} sortFunction={toggleSortNumber} />    
          </TableRow>
        </TableHead>
        <TableBody onClick={() => closeSorts()}>
          {table.length ? (
            <>
              {table.map(item => {
                return (
                  <TableItem
                    item={item}
                    key={item.postExamId}
                    hoverInfo={hoverOval}
                    hideTooltip={hideTooltip}
                  />
                );
              })}
            </>
          ) : (
            <TableRow>
              <TableColumn colSpan={20}>No data</TableColumn>
            </TableRow>
          )}
        </TableBody>
      </TableDefault>
      <TooltipFatigueZones section={tooltipSection} tooltipRef={tooltipRef} />
    </>
  );
};

const TableItem = ({item, hoverInfo, hideTooltip }) => {
  return (
    <TableRow>
      <TableColumn bgColor={'white'}>{handleDate(item.date)}</TableColumn>
      <TableColumn bgColor={'white'}>{capitalizeFirstLetters(item.event.type, '_')}</TableColumn>      
      <TableColumn bgColor={'white'}>
        {item.event.type === 'velo_day' ? 
          capitalizeFirstLetters(item.event.highIntentsThrows, ' ') : 
          numberColumnFormatter(item.event.pitches, {digits: 0 })}
      </TableColumn>      
      <TableColumn bgColor={'white'}>{numberColumnFormatter(item.event.rpe, {digits: 0 })}</TableColumn>      
      <TableColumn>
        {numberColumnFormatter(item.strength.freshTotalRatio, {digits: 0 })}
        {getFatigueZoneBullet(item.strength.armFatigueTotal, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>      
      <TableColumn>{numberColumnFormatter(item.strength.freshTotalChange)}</TableColumn>            
      <TableColumn bgColor={'white'}>
        {numberColumnFormatter(item.strength.freshIRRatio, {digits: 0 })}
        {getFatigueZoneBullet(item.strength.armFatigueIR, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
        </TableColumn>      
      <TableColumn bgColor={'white'}>{numberColumnFormatter(item.strength.freshIRChange)}</TableColumn>      
      <TableColumn>
        {numberColumnFormatter(item.strength.freshERRatio, {digits: 0 })}
        {getFatigueZoneBullet(item.strength.armFatigueER, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>      
      <TableColumn>{numberColumnFormatter(item.strength.freshERChange)}</TableColumn>      
      <TableColumn bgColor={'white'}>
        {numberColumnFormatter(item.strength.freshScaptionRatio, {digits: 0 })}
        {getFatigueZoneBullet(item.strength.armFatigueScaption, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>      
      <TableColumn bgColor={'white'}>{numberColumnFormatter(item.strength.freshScaptionChange)}</TableColumn>      
      <TableColumn >
        {numberColumnFormatter(item.strength.freshGripRatio, {digits: 0 })}
        {getFatigueZoneBullet(item.strength.armFatigueGrip, [hoverInfo, [ArmFatigue, 'freshP', '% Fresh'], hideTooltip])}
      </TableColumn>      
      <TableColumn>{numberColumnFormatter(item.strength.freshGripChange)}</TableColumn>      
    </TableRow>
  );
};
